import Button from "@/components/editorial/Button";
import Eyebrow from "@/components/editorial/Eyebrow";
import HeroBackgroundVideos from "@/components/editorial/HeroBackgroundVideos";

const HERO_VIDEOS = [
  // 1 — Microscopio · Woman Looking Through the Microscope (Artem Podrez)
  //     https://www.pexels.com/video/a-woman-looking-through-the-microscope-5752729/
  "https://videos.pexels.com/video-files/5752729/5752729-hd_1920_1080_30fps.mp4",
  // 2 — Agricultura · Woman with Basket Working on Field (Zomlien Neihsiel)
  //     https://www.pexels.com/video/woman-with-basket-working-on-field-13223262/
  "https://videos.pexels.com/video-files/13223262/13223262-hd_1920_1080_60fps.mp4",
  // 3 — Ejecutiva · Businesswoman Using Laptop in Office · Los Muertos Crew (MX)
  //     https://www.pexels.com/video/businesswoman-using-laptop-in-office-10040728/
  "https://videos.pexels.com/video-files/10040728/10040728-hd_1920_1080_24fps.mp4",
];
const VIDEO_POSTER =
  "https://images.pexels.com/photos/1308881/pexels-photo-1308881.jpeg?auto=compress&cs=tinysrgb&w=1920&dpr=2";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative w-full h-screen min-h-[700px] overflow-hidden bg-charcoal"
    >
      <HeroBackgroundVideos
        videos={HERO_VIDEOS}
        poster={VIDEO_POSTER}
        displayMs={7000}
        fadeMs={1500}
      />
      <div className="absolute inset-0 bg-charcoal/45" />
      <div className="absolute inset-0 bg-gradient-to-b from-charcoal/20 via-transparent to-charcoal/90" />

      <div className="relative z-10 mx-auto max-w-[1440px] h-full px-6 sm:px-8 md:px-12 lg:px-16 flex flex-col justify-end pb-20 md:pb-28">
        <div className="max-w-4xl">
          <Eyebrow tone="gold" className="mb-6 animate-fade-up" >
            Plataforma editorial · México 2026
          </Eyebrow>
          <h1
            data-testid="hero-title"
            className="font-serif text-cream font-light leading-[0.95] tracking-tight animate-fade-up"
            style={{
              fontSize: "clamp(3rem, 7.5vw, 6.5rem)",
              animationDelay: "120ms",
            }}
          >
            Mujeres
            <br />
            <span className="italic text-terracotta">Motor</span>
          </h1>
          <p
            data-testid="hero-tagline"
            className="font-serif italic text-cream/95 mt-6 max-w-2xl leading-tight animate-fade-up"
            style={{
              fontSize: "clamp(1.35rem, 2.4vw, 2.1rem)",
              animationDelay: "220ms",
            }}
          >
            Historias reales. Comunidad viva. Impacto visible.
          </p>
          <p
            data-testid="hero-subtitle"
            className="text-cream/80 mt-5 text-base md:text-lg max-w-xl animate-fade-up"
            style={{ animationDelay: "320ms" }}
          >
            La plataforma que visibiliza a las mujeres que están moviendo México.
          </p>

          <div
            className="flex flex-wrap gap-3 md:gap-4 mt-10 animate-fade-up"
            style={{ animationDelay: "420ms" }}
          >
            <Button to="/stories" variant="primary" data-testid="cta-stories">
              Ver historias
            </Button>
            <Button to="/nominate" variant="outlineCream" data-testid="cta-nominate">
              Postula una historia
            </Button>
            <Button to="/for-brands" variant="outlineCream" data-testid="cta-sponsor">
              Patrocina la plataforma
            </Button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-cream/50 text-[10px] uppercase tracking-[0.3em] z-10">
        <span className="inline-block animate-pulse">↓ Explora</span>
      </div>
    </section>
  );
}
